<template>
  <div>
    <div class="row gy-5 g-xl-8">
      <div
        class="col-xl-12"
        :class="{ 'mt-1': view !== 'ultimos' && filtroCliente !== '' }"
      >
        <div class="mb-5 mb-xl-8" :class="{ 'card card-xl-stretch': !dialog }">
          <div
            class="d-flex justify-content-center"
            v-if="view !== 'ultimos' && filtroCliente !== ''"
          >
            <div class="mb-3 text-center me-7">
              <div>
                <div class="m-0 text-center">
                  <h5 class="fw-bold fs-6 text-dark me-5 mt-3">Usuários</h5>
                </div>
              </div>
              <div class="d-flex justify-content-center flex-wrap d-grid gap-2">
                <!--begin::Item-->
                <div class="d-flex align-items-center pe-3">
                  <!--begin::Info-->
                  <div class="m-0 text-center">
                    <span class="fw-semibold text-gray-500 d-block fs-8"
                      >Total</span
                    >
                    <span class="fw-bold text-gray-800 fs-7">{{
                      estatisticas.usuariosTotal
                    }}</span>
                  </div>
                  <div class="ms-2 m-0 text-center">
                    <span class="fw-semibold text-gray-500 d-block fs-8"
                      >Alocados</span
                    >
                    <span class="fw-bold text-gray-800 fs-7">{{
                      estatisticas.usuariosAlocado
                    }}</span>
                  </div>
                  <div class="ms-2 m-0 text-center">
                    <span class="fw-semibold text-gray-500 d-block fs-8"
                      >Em Uso</span
                    >
                    <span class="fw-bold text-gray-800 fs-7">{{
                      estatisticas.usuariosOcupado
                    }}</span>
                  </div>
                  <!--end::Info-->
                </div>
                <!--end::Item-->
              </div>
            </div>

            <div class="mb-3 text-center">
              <div>
                <div class="m-0 text-center">
                  <h5 class="fw-bold fs-6 text-dark me-5 mt-3">Espaço</h5>
                </div>
              </div>
              <div class="d-flex justify-content-center flex-wrap d-grid gap-2">
                <!--begin::Item-->
                <div class="d-flex align-items-center pe-3">
                  <!--begin::Info-->
                  <div class="m-0 text-center">
                    <span class="fw-semibold text-gray-500 d-block fs-8"
                      >Total</span
                    >
                    <span class="fw-bold text-gray-800 fs-7"
                      >{{
                        (estatisticas.espacoTotal > 0
                          ? estatisticas.espacoTotal / 1024 / 1024 / 1024
                          : 0
                        ).toFixed(2)
                      }}
                      GB</span
                    >
                  </div>
                  <div class="ms-2 m-0 text-center">
                    <span class="fw-semibold text-gray-500 d-block fs-8"
                      >Alocados</span
                    >
                    <span class="fw-bold text-gray-800 fs-7"
                      >{{
                        (estatisticas.espacoAlocado > 0
                          ? estatisticas.espacoAlocado / 1024 / 1024 / 1024
                          : 0
                        ).toFixed(2)
                      }}
                      GB</span
                    >
                  </div>
                  <div class="ms-2 m-0 text-center">
                    <span class="fw-semibold text-gray-500 d-block fs-8"
                      >Em Uso</span
                    >
                    <span class="fw-bold text-gray-800 fs-7"
                      >{{
                        (estatisticas.espacoOcupado > 0
                          ? estatisticas.espacoOcupado / 1024 / 1024 / 1024
                          : 0
                        ).toFixed(2)
                      }}
                      GB</span
                    >
                  </div>
                  <!--end::Info-->
                </div>
                <!--end::Item-->
              </div>
            </div>
          </div>

          <div
            class="border-0"
            :class="{
              'card-header pt-6': !dialog,
              'd-flex justify-content-between': dialog
            }"
            v-if="view !== 'ultimos'"
          >
            <div
              class="d-flex justify-content-start"
              :class="{ 'card-title': !dialog }"
            >
              <div class="d-flex align-items-center position-relative my-1">
                <span class="svg-icon svg-icon-1 position-absolute ms-6">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <rect
                      opacity="0.5"
                      x="17.0365"
                      y="15.1223"
                      width="8.15546"
                      height="2"
                      rx="1"
                      transform="rotate(45 17.0365 15.1223)"
                      fill="currentColor"
                    ></rect>
                    <path
                      d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                      fill="currentColor"
                    ></path>
                  </svg>
                </span>

                <input
                  type="text"
                  class="form-control form-control-solid w-250px ps-14"
                  placeholder="Pesquisar"
                  @keyup="keyupFiltroTexto"
                  v-model="filtroTexto"
                  autocomplete="off"
                />
              </div>

              <div class="ms-5 mt-2" v-if="false">
                <div class="fw-bolder">Usuários alocados</div>
                <div class="text-gray-600">
                  {{ estatisticas.usuariosAlocado }} de
                  {{ estatisticas.usuariosTotal }}
                </div>
              </div>

              <div class="ms-5 mt-2" v-if="false">
                <div class="fw-bolder">Espaço alocado</div>
                <div class="text-gray-600">
                  {{ estatisticas.espacoAlocado }} de
                  {{ estatisticas.espacoTotal }} GB
                </div>
              </div>
            </div>

            <div class="card-toolbar">
              <div
                class="d-flex justify-content-end"
                data-kt-user-table-toolbar="base"
                data-select2-id="select2-data-132-7t2c"
                v-if="botaoNovo"
              >
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="novoItem()"
                  :disabled="
                    estatisticas.usuariosAlocado >=
                      estatisticas.usuariosTotal ||
                    estatisticas.espacoAlocado >= estatisticas.espacoTotal
                  "
                >
                  <span class="svg-icon svg-icon-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <rect
                        opacity="0.5"
                        x="11.364"
                        y="20.364"
                        width="16"
                        height="2"
                        rx="1"
                        transform="rotate(-90 11.364 20.364)"
                        fill="currentColor"
                      ></rect>
                      <rect
                        x="4.36396"
                        y="11.364"
                        width="16"
                        height="2"
                        rx="1"
                        fill="currentColor"
                      ></rect>
                    </svg>
                  </span>
                  Novo
                </button>
              </div>
            </div>
          </div>

          <div class="card-body py-3">
            <div class="table-responsive">
              <table
                class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4"
              >
                <thead>
                  <tr class="fw-bolder text-muted">
                    <th class="w-25px" style="display: none">
                      <div
                        class="form-check form-check-sm form-check-custom form-check-solid"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value="1"
                          data-kt-check="true"
                          data-kt-check-target=".widget-9-check"
                        />
                      </div>
                    </th>
                    <th class="min-w-200px">
                      <span
                        class="cursor-pointer"
                        :class="{
                          'table-sort-desc':
                            ordem.campo == 'nome' && ordem.tipo == 'ASC',
                          'table-sort-asc':
                            ordem.campo == 'nome' && ordem.tipo == 'DESC'
                        }"
                        v-if="view !== 'ultimos'"
                        @click="alterarOrdem('nome')"
                        >Nuvens ({{ itensTotal }})</span
                      >
                      <span class="cursor-pointer" v-if="view == 'ultimos'"
                        >Nuvens recentes</span
                      >
                    </th>
                    <th class="w-150px min-w-150px" v-if="view !== 'ultimos'">
                      Cliente
                    </th>
                    <th class="w-300px min-w-200px" v-if="view !== 'ultimos'">
                      <span
                        class="cursor-pointer"
                        :class="{
                          'table-sort-desc':
                            ordem.campo == 'consumo' && ordem.tipo == 'ASC',
                          'table-sort-asc':
                            ordem.campo == 'consumo' && ordem.tipo == 'DESC'
                        }"
                        @click="alterarOrdem('consumo')"
                        >Espaço utilizado</span
                      >
                    </th>
                    <th class="w-150px text-center" v-if="view !== 'ultimos'">
                      Status
                    </th>
                    <th class="w-40px text-end">Opções</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="item in itens" :key="item._id" :item="item">
                    <td style="display: none">
                      <div
                        class="form-check form-check-sm form-check-custom form-check-solid"
                      >
                        <input
                          class="form-check-input widget-9-check"
                          type="checkbox"
                          value="1"
                        />
                      </div>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="symbol symbol-45px me-5 mt-1 mb-1 mx-1">
                          <i class="bi bi-cloud text-primary fs-2hx gx-5"></i>
                        </div>
                        <div class="d-flex justify-content-start flex-column">
                          <span
                            class="text-dark fw-bolder text-hover-primary fs-6"
                            style="cursor: pointer"
                            @click="editarItem(item._id)"
                          >
                            {{ item.nome }}
                          </span>
                          <span
                            class="text-muted fw-bold text-muted d-block fs-7"
                          >
                            {{
                              item.alias
                                ? "@" + item.alias
                                : "@" +
                                  item.nome.replaceAll(" ", "").toLowerCase()
                            }}</span
                          >
                        </div>
                      </div>
                    </td>
                    <td v-if="view !== 'ultimos'">
                      <div class="d-flex justify-content-start flex-column">
                        <span class="text-dark fw-bolder fs-6">
                          {{ item.cliente.nome ? item.cliente.nome : "" }}
                        </span>
                        <span class="text-muted fw-bold text-muted d-block fs-7"
                          >{{ item.usuarios.length }} de
                          {{ item.usuariosTotal }} usuários</span
                        >
                      </div>
                    </td>

                    <td class="text-end" v-if="view !== 'ultimos'">
                      <div class="d-flex flex-column w-100 me-2">
                        <div class="mb-2">
                          <span class="text-muted me-2 fs-7 fw-bold"
                            ><small
                              >{{
                                $funcoes.porcentagem(
                                  item.espacoOcupado,
                                  item.espacoTotal
                                )
                              }}%</small
                            ></span
                          >
                        </div>
                        <div class="progress h-6px w-100 mb-2">
                          <div
                            class="progress-bar bg-primary"
                            role="progressbar"
                            :style="{
                              width:
                                $funcoes.porcentagem(
                                  item.espacoOcupado,
                                  item.espacoTotal
                                ) + '%'
                            }"
                            :aria-valuenow="item.espacoOcupado"
                            aria-valuemin="0"
                            :aria-valuemax="item.espacoTotal"
                          ></div>
                        </div>
                        <div class="d-flex flex-stack">
                          <span class="text-muted me-2 fs-7 fw-bold"
                            ><small>{{
                              $funcoes.tamanhoTexto(item.espacoOcupado)
                            }}</small>
                          </span>

                          <span class="text-muted me-2 fs-7 fw-bold"
                            ><small>{{
                              $funcoes.tamanhoTexto(item.espacoTotal)
                            }}</small></span
                          >
                        </div>
                      </div>
                    </td>
                    <td class="text-center" v-if="view !== 'ultimos'">
                      <span
                        class="badge badge-light-success"
                        v-if="item.status == true"
                        >Ativo</span
                      >
                      <span
                        class="badge badge-light-danger"
                        v-if="item.status == false"
                        >Inativo</span
                      >
                    </td>
                    <td>
                      <div class="d-flex justify-content-end flex-shrink-0">
                        <button
                          class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Grupos"
                          @click="abrirListaGrupo(item.cliente._id, item._id)"
                          v-if="false"
                        >
                          <span class="svg-icon svg-icon-3">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-people-fill"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                              />
                              <path
                                fill-rule="evenodd"
                                d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"
                              />
                              <path
                                d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"
                              />
                            </svg>
                          </span>
                        </button>
                        <button
                          class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Usuários"
                          @click="abrirListaUsuario(item.cliente._id, item._id)"
                        >
                          <span class="svg-icon svg-icon-3">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              fill="currentColor"
                              class="bi bi-person-fill"
                              viewBox="0 0 16 16"
                            >
                              <path
                                d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                              />
                            </svg>
                          </span>
                        </button>
                        <button
                          class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Editar"
                          @click="editarItem(item._id)"
                        >
                          <span class="svg-icon svg-icon-3">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                opacity="0.3"
                                d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                                fill="currentColor"
                              ></path>
                              <path
                                d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                                fill="currentColor"
                              ></path>
                            </svg>
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <Paginacao
              ref="paginacao"
              :total="itensTotal"
              :limit="20"
              :class="{ 'd-none': view == 'ultimos' }"
              @change-pagina="carregarItens()"
            />
          </div>
        </div>
      </div>
    </div>

    <NuvemEdit
      ref="formNuvem"
      view="modal"
      @dialog-on="
        if (this.dialog) {
          $emit('dialog-on');
        }
      "
      @dialog-off="
        if (this.dialog) {
          $emit('dialog-off');
        }
        carregarItens();
      "
    />

    <GrupoListDialog
      ref="listGrupo"
      @dialog-on="
        if (this.dialog) {
          $emit('dialog-on');
        }
      "
      @dialog-off="
        if (this.dialog) {
          $emit('dialog-off');
        }
        carregarItens();
      "
    />
    <UsuarioListDialog
      ref="listUsuario"
      @dialog-on="
        if (this.dialog) {
          $emit('dialog-on');
        }
      "
      @dialog-off="
        if (this.dialog) {
          $emit('dialog-off');
        }
        carregarItens();
      "
    />
  </div>
</template>

<script>
import { api } from "@/plugins/api.js";

//import Combo from "../../components/ComponentCombo.vue";
import Paginacao from "../components/ComponentPaginacao.vue";
import NuvemEdit from "./NuvemEdit.vue";
import GrupoListDialog from "./GrupoListDialog.vue";
import UsuarioListDialog from "./UsuarioListDialog.vue";

export default {
  components: { NuvemEdit, GrupoListDialog, UsuarioListDialog, Paginacao },

  props: {
    dialog: { type: Boolean, default: false },
    view: { type: String, default: "" },
    botaoNovo: { type: Boolean, default: true }
  },

  data() {
    return {
      timerFiltroTexto: null,
      itensTotal: 0,
      filtroTexto: "",
      filtroCliente: "",
      filtroStorage: "",
      ordem: { campo: "nome", tipo: "ASC" },
      itens: [],
      estatisticas: {
        espacoTotal: 0,
        espacoAlocado: 0,
        espacoOcupado: 0,
        usuariosTotal: 0,
        usuariosAlocado: 0,
        usuariosOcupado: 0
      }
    };
  },

  mounted() {
    this.carregarItens();
  },

  methods: {
    async carregarItens() {
      let filtros = "";

      //* Filtra os ultimos itens
      if (this.view == "ultimos") {
        filtros += "?_limit=" + 10;
        filtros += "&_ordem=dataCriacao_DESC";
      } else {
        filtros += "?_limit=" + 20;
        filtros += "&_page=" + this.$refs.paginacao.pagina;
        filtros += "&_ordem=" + this.ordem.campo + "_" + this.ordem.tipo;
      }

      if (this.filtroTexto !== "") {
        filtros += "&_all=" + this.filtroTexto;
      }

      if (this.filtroCliente !== "") {
        filtros += "&cliente=" + this.filtroCliente;
      }

      if (this.filtroStorage !== "") {
        filtros += "&storage=" + this.filtroStorage;
      }

      const response = await api.get(
        window._env_.VUE_APP_URL_API + "/admin/nuvem" + filtros
      );
      api.valid(response.data, this.$router);

      this.itens = response.data.itens;
      this.itensTotal = response.data.total;

      setTimeout(function () {
        window.KTApp.initBootstrapTooltips();
      }, 200);
    },
    async editarItem(id) {
      await this.$refs.formNuvem.carregarItem(id);
      this.$refs.formNuvem.abrir();
    },
    async novoItem() {
      if (this.filtroCliente !== "") {
        await this.$refs.formNuvem.novo();
        this.$refs.formNuvem.item.cliente = this.filtroCliente;
        this.$refs.formNuvem.abrir();
      }
    },
    abrirListaUsuario(cliente, nuvem) {
      this.$refs.listUsuario.abrirNuvem(cliente, nuvem);
    },
    abrirListaGrupo(cliente, nuvem) {
      this.$refs.listGrupo.abrirNuvem(cliente, nuvem);
    },
    alterarOrdem(campo) {
      //* Verifica se o campo foi mantido
      if (this.ordem.campo == campo) {
        //* Verifica a ordem atual e altera para a nova
        if (this.ordem.tipo == "ASC") {
          this.ordem.tipo = "DESC";
        } else {
          this.ordem.tipo = "ASC";
        }
      } else {
        //* Altera para ordenar o novo campo
        this.ordem.campo = campo;
        this.ordem.tipo = "ASC";
      }

      //* Recarrega os itens com nova ordem
      this.carregarItens();
    },
    keyupFiltroTexto() {
      clearTimeout(this.timerFiltroTexto);

      const obj = this;

      this.timerFiltroTexto = setTimeout(function () {
        //obj.$refs.paginacao.pagina = 1;
        obj.carregarItens();
      }, 300);
    }
  }
};
</script>

<style></style>
